export { default as archiveCustomTermsTemplate } from './archiveCustomTermsTemplate';
export { default as updateOrCreateCustomTermsTemplate } from './updateOrCreateCustomTermsTemplate';
